import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useAppConfig } from "@fdoh/health-ui-react";
import InspectionClient from "../clients/InspectionJwtClient";
import { JwtResponse, RefreshToken, AccessToken } from "../types";
import useAuthService from "./useAuthService";

export const useInspectionClient = () => {
    const { instance, accounts } = useMsal();
    const config = useAppConfig();    
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    let jwtResponse;
    // jwtResponse = useAuthService<JwtResponse>(application);

   // 
   // console.log("useAuthService:: " + JSON.stringify(jwtResponse));
    const client = new InspectionClient(accounts[0] as AccountInfo, instance, application, undefined);

    return client;
};

export default useInspectionClient;
